module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wilchingen-7b5d54a2040682e28acf936c1d26b56f.png";